// extracted by mini-css-extract-plugin
export default {"container":"Yca-z","heading":"Zca-z","links":"_ca-z","linkBtn":"ada-z","disabled":"bda-z","linkUppercaseBold":"cda-z","copy":"dda-z","subCopy":"eda-z"};